import React from "react";
import CompanyContainer from "../containers/CompanyContainer";
import EmployeeContainer from "../containers/EmployeeContainer";
import MergeLogsList from "../containers/EmployeeContainer/MergeCharts/MergeLogsList";
import CloneLogsList from "../containers/EmployeeContainer/CloneHistory/CloneLogsList";
import EmployerEmployeeContainer from "../containers/EmployerEmployeeContainer/index.js";
import Appointments from "../containers/AppointmentsContainer";
import Dashboard from "../containers/DashboardContainer";
import { ClinicsLocationContainer } from "../containers/ClinicLocationContainer/index";
import EmployeeVisitContainer from "../containers/EmployeeVisitContainer";
import ResultContainer from "../containers/ResultContainer";
import WhiteBoardContainer from "../containers/WhiteBoardContainer";
import PERMISSIONS from "../utils/AclPermissions";
import AuditLogContainer from "../containers/AuditLogContainer";
import RandomGeneratorConfig from "../containers/RandomGeneratorConfigContainer/RandomGeneratorConfig";
import IncidentList from "../containers/IncidentContainer/IncidentList";
import Authentication from "../containers/ProfileContainer/Authentication";
import VideoConfigList from "../containers/VideoConfigContainer/VideoConfigList.js";
import DashboardNavigate from "../containers/DashboardContainer/DashboardNavigate.js";
import NotificationTemplateList from "../containers/NotificationTemplate/NotificationTemplateList.js";
import DataPermissionTemplateList from "../containers/DataPermissionTemplate/DataPermissionTemplateList.js";
const WorkCompInsuranceContainer = React.lazy(() => import("../containers/WorkCompInsuranceContainer"));
const User = React.lazy(() => import("../containers/UserContainer"));
const Roles = React.lazy(() => import("../containers/RolesContainer"));
const Unauthorized = React.lazy(() => import("./Unauthorized"));
const ClinicContainer = React.lazy(() => import("../containers/ClinicContainer"));
const organisationContainer = React.lazy(() => import("../containers/OrganisationContainer"));
const Profile = React.lazy(() => import("../containers/ProfileContainer/Profile"));
const ChangePassword = React.lazy(() => import("../containers/ProfileContainer/ChangePassword"));
const InsuranceContainer = React.lazy(() => import("../containers/InsuranceContainer"));
const DivisionContainer = React.lazy(() => import("../containers/DivisionContainer"));
const LookupContainer = React.lazy(() => import("../containers/LookupContainer"));
const ActivitiesContainer = React.lazy(() => import("../containers/ActivitiesContainer"));
const PricingContainer = React.lazy(() => import("../containers/PricingContainer"));
const ContractApprovalContainer = React.lazy(() => import("../containers/ContractApprovalContainer"));
const BasicPhysicalContainer = React.lazy(() => import("../containers/BasicPhysicalContainer"));
const ProviderContainer = React.lazy(() => import("../containers/ProviderContainer"));
const ReferralProviderContainer = React.lazy(() => import("../containers/ReferralProviderContainer"));
const CPTContainer = React.lazy(() => import("../containers/CPTContainer"));
const ICD10Container = React.lazy(() => import("../containers/ICD10Container"));
const LaboratoryContainer = React.lazy(() => import("../containers/LaboratoryContainer"));
const LabContainer = React.lazy(() => import("../containers/LabContainer"));
const ConsentFormContainer = React.lazy(() => import("../containers/ConsentFormContainer"));
const VaccineAdministrationContainer = React.lazy(() => import("../containers/ActivitiesContainer/VaccineAdministrationContainer"));
const ReportsContainer = React.lazy(() => import("../containers/ReportsContainer"));
const CSVContainer = React.lazy(() => import("../containers/CSVContainer"));
const HistoricalVisitImportContainer = React.lazy(() =>
  import("../containers/HistoricalVisitImportContainer")
);
const EzReaderContainer = React.lazy(() => import("../containers/EzReaderContainer"));
const NotificationContainer = React.lazy(() => import("../containers/NotificationContainer"));
const ConfigurationContainer = React.lazy(() => import("../containers/ConfigurationContainer"));
const HL7Container = React.lazy(() => import("../containers/HL7Container"));
const EmrConfig = React.lazy(() => import("../containers/EmrFieldsConfigContainer/index"));
const ScheduledPatientsContainer = React.lazy(() => import("../containers/ScheduledPatientsContainer"));
const FormsConfigurationContainer = React.lazy(() => import("../containers/FormsConfigurationContainer"));
const LabPannelImportConfig = React.lazy(() => import("../containers/LabPannelImportConfig/LabImportConfigList"));
const LabPannelImport = React.lazy(() => import("../containers/LabPannelImport/index.js"));
const ComplianceMonitorContainer = React.lazy(() =>
  import("../containers/ComplianceMonitorContainer")
);
const defaultConfig = {
  layoutType: "App",
  routeType: "Auth",
};
const PublicRoutes = [
  {
    path: "/",
    exact: true,
    element: DashboardNavigate,
    acl: ["any"],
    ...defaultConfig,
    // Add more properties as needed
  },
  {
    path: "/unauthorized",
    exact: true,
    element: Unauthorized,
    acl: ["any"],
    ...defaultConfig,
    // Add more properties as needed
  },
  {
    path: "/dashboard",
    exact: true,
    element: DashboardNavigate,
    ...defaultConfig,
    acl: [PERMISSIONS.DASHBOARD.LIST],
    // Add more properties as needed
  },
  {
    path: "/users/*",
    exact: true,
    element: User,
    acl: [PERMISSIONS.USER.LIST],
    ...defaultConfig,
  },
  {
    path: "/roles/*",
    exact: true,
    element: Roles,
    acl: [PERMISSIONS.ROLE.LIST],
    ...defaultConfig,
  },
  {
    path: "/labs/*",
    exact: true,
    element: LabContainer,
    acl: [PERMISSIONS.RESULT.LIST],
    // acl:['role-list','role-edit'],
    ...defaultConfig,
  },
  {
    path: "/clinics/*",
    exact: true,
    element: ClinicContainer,
    acl: [PERMISSIONS.CLINIC.LIST],
    // acl:['role-list','role-edit'],
    ...defaultConfig,
    // Add more public routes as needed
  },
  {
    path: "/providers/*",
    exact: true,
    element: ProviderContainer,
    acl: [PERMISSIONS.PROVIDER.LIST],
    ...defaultConfig,
  },
    {
    path: "/referral-providers/*",
    exact: true,
    element:ReferralProviderContainer,
    acl: [PERMISSIONS.REFERRAL_PROVIDER.LIST],
    ...defaultConfig,
  },
  {
    path: "/clincs-department/*",
    exact: true,
    element: ClinicsLocationContainer,
    acl: [PERMISSIONS.CLINIC_DEPARTMENT.LIST],
    // acl:['role-list','role-edit'],
    ...defaultConfig,
  },
  {
    path: "/organisation/*",
    exact: true,
    element: organisationContainer,
    acl: [PERMISSIONS.ORGANIZATION.LIST],
    // acl:['role-list','role-edit'],
    ...defaultConfig,
  },
  {
    path: "/profile",
    exact: true,
    element: Profile,
      acl: ["any"],
    // acl:['role-list','role-edit'],
    ...defaultConfig,
  },
  {
    path: "/authentication",
    exact: true,
    element: Authentication,
      acl: ["any"],
    ...defaultConfig,
  },
  {
    path: "/company/*",
    exact: true,
    element: CompanyContainer,
      acl: [PERMISSIONS.COMPANY.LIST],
    ...defaultConfig,
  },
  {
    path: "/employer-employee/*",
    exact: true,
    element: EmployerEmployeeContainer,
      acl: [PERMISSIONS.EMPLOYEE.LIST],
    ...defaultConfig,
  },
  {
    path: "/employee/*",
    exact: true,
    element: EmployeeContainer,
      acl: [PERMISSIONS.EMPLOYEE.LIST],
    ...defaultConfig,
  },
  {
    path: "/merge-history",
    exact: true,
    element: MergeLogsList,
    acl: [PERMISSIONS.MERGE_PATIENT.LIST],
    ...defaultConfig,
  },
  {
    path: "/clone-history",
    exact: true,
    element: CloneLogsList,
    acl: [PERMISSIONS.EMPLOYEE.EDIT],
    ...defaultConfig,
  },
  {
    path: "/visits/*",
    exact: true,
    element: EmployeeVisitContainer,
    acl: [PERMISSIONS.VISITS.LIST],
    aclWhenRole: {
      employer_admin: "any",
    },
    ...defaultConfig,
  },
  {
    path: "/white-board/*",
    exact: true,
    element: WhiteBoardContainer,
      acl: [PERMISSIONS.WHITE_BOARD.LIST],
    ...defaultConfig,
  },
  {
    path: "/appointments/*",
    exact: true,
    element: Appointments,
      acl: [PERMISSIONS.APPOINTMENT.LIST],
      aclWhenRole: {
        employer_admin: "any",
      },
    ...defaultConfig,
  },
  {
    path: "/insurance/*",
    exact: true,
    element: InsuranceContainer,
      acl: [PERMISSIONS.INSURANCE.LIST],
    ...defaultConfig,
  },
  {
    path: "/division/*",
    exact: true,
    element: DivisionContainer,
      acl: [PERMISSIONS.COMPANY_DIVISION.LIST],
    ...defaultConfig,
  },
  {
    path: "/lookup/*",
    exact: true,
    element: LookupContainer,
      acl: [PERMISSIONS.LOOKUP.LIST],
    ...defaultConfig,
  },
 
  {
    path: "/activities/*",
    exact: true,
    element: ActivitiesContainer,
      acl: [PERMISSIONS.ACTIVITIES.LIST],
    ...defaultConfig,
  },
  {
    path: "/pricing/*",
    exact: true,
    element: PricingContainer,
      acl: [PERMISSIONS.PRICING.LIST],
    ...defaultConfig,
  },
  {
    path: "/contract/*",
    exact: true,
    element: ContractApprovalContainer,
      acl: [PERMISSIONS.CONTRACT.LIST],
    ...defaultConfig,
  },

  {
    path: "/intake-paperwork/*",
    exact: true,
    element: ConsentFormContainer,
      acl: [PERMISSIONS.CONSENT.LIST],
    ...defaultConfig,
  },
  
  {
    path: "/basic-physical/*",
    exact: true,
    element: BasicPhysicalContainer,
      acl: [PERMISSIONS.BASIC_PHYSICAL.LIST],
    ...defaultConfig,
  },
  {
    path: "/cpt-code/*",
    exact: true,
    element: CPTContainer,
      acl: [PERMISSIONS.CPT.LIST],
    ...defaultConfig,
  },
  {
    path: "/icd10-code/*",
    exact: true,
    element: ICD10Container,
      acl: [PERMISSIONS.ICD10.LIST],
    ...defaultConfig,
  },
  {
    path: "/laboratory/*",
    exact: true,
    element: LaboratoryContainer,
    acl: [PERMISSIONS.LAB.LIST],
    // acl:['role-list','role-edit'],
    ...defaultConfig,
  },
  {
    path: "/vaccine-administration/*",
    exact: true,
    element: VaccineAdministrationContainer,
    acl: [PERMISSIONS.VACCINE_ADMINISTRATION.LIST],
    // acl:['role-list','role-edit'],
    ...defaultConfig,
  },
  {
    path: "result/*",
    exact: true,
    element: ResultContainer,
    acl: [PERMISSIONS.RESULT.LIST],
    // acl:['role-list','role-edit'],
    ...defaultConfig,
  },
  {
    path: "reports/*",
    exact: true,
    element:ReportsContainer,
    acl: [PERMISSIONS.REPORTS.LIST],
    // acl:['role-list','role-edit'],
    ...defaultConfig,
  },
  {
    path: "csv-import/*",
    exact: true,
    element: CSVContainer,
    acl: [PERMISSIONS.CSV_IMPORT.LIST],
    // acl:['role-list','role-edit'],
    ...defaultConfig,
  },
  {
    path: "historical-visit-import/*",
    exact: true,
    element: HistoricalVisitImportContainer,
    acl: [PERMISSIONS.HISTORICAL_VISIT.LIST, PERMISSIONS.CSV_IMPORT.LIST],
    ...defaultConfig,
  },
  {
    path: "failed-ez-reader/*",
    exact: true,
    element: EzReaderContainer,
    acl: [PERMISSIONS.FAILED_EZ_READER.LIST],
    ...defaultConfig,
  },
  {
    path: "notification-log/*",
    exact: true,
    element: NotificationContainer,
    acl: [PERMISSIONS.NOTIFICATION_LOG.LIST],
    ...defaultConfig,
  },
  {
    path: "configure/*",
    exact: true,
    element: ConfigurationContainer,
    acl: [PERMISSIONS.SFTP_CONFIGURATION.LIST],
    ...defaultConfig,
  },
  {
    path: "hl7/*",
    exact: true,
    element: HL7Container,
    acl: [PERMISSIONS.HL7_LOG.LIST],
    ...defaultConfig,
  },
  {
    path: "workcomp-insurance/*",
    exact: true,
    element: WorkCompInsuranceContainer,
    acl: [PERMISSIONS.WORK_COMP_INSURANCE.LIST],
    ...defaultConfig,
  },
  {
    path: "/audit-log/*",
    exact: true,
    element: AuditLogContainer,
    acl: [PERMISSIONS.AUDIT_LOG.LIST],
    ...defaultConfig,
  },
  {
    path: "/compliance-monitor/*",
    exact: true,
    element: ComplianceMonitorContainer,
    acl: [PERMISSIONS.COMPLIANCE_MONITOR.LIST],
    ...defaultConfig,
  },
  {
    path: "/ai-diagnosis-logs/*",
    exact: true,
    element: React.lazy(() => import("../containers/AiDiagnosisLogContainer")),
    acl: [PERMISSIONS.AI_DIAGNOSIS_LOGS.LIST],
    ...defaultConfig,
  },
  {
    path: "/dot-submission-logs/*",
    element: React.lazy(() => import("../containers/DotSubmissionLogContainer")),
    acl: [PERMISSIONS.DOT_SUBMISSION_LOGS.LIST],
    ...defaultConfig,
  },
  {
    path: "/emr/*",
    exact: true,
    element:EmrConfig ,
      acl: [PERMISSIONS.EMR_CONFIGURATION.LIST],
    ...defaultConfig,
  },
   {
    path: "/random-generator",
    exact: true,
    element:RandomGeneratorConfig,
      acl: [PERMISSIONS.RANDOM_GENERATOR.LIST],
    ...defaultConfig,
  },
  {
    path: "/random-scheduled-patients",
    exact: true,
    element:ScheduledPatientsContainer ,
      acl: [PERMISSIONS.VISIT_SCHEDULE.LIST],
    ...defaultConfig,
  },
    {
    path: "incident/*",
    exact: true,
    element:IncidentList,
    acl: [PERMISSIONS.INCIDENT.LIST],
    // acl:['role-list','role-edit'],
    ...defaultConfig,
  },
  {
    path: "/forms-configuration",
    exact: true,
    element:FormsConfigurationContainer ,
    acl: [PERMISSIONS.STATE_FORMS.LIST],
    ...defaultConfig,
    },
    {
      path: "/lab-pannel-configuration",
      exact: true,
      element:LabPannelImportConfig,
      acl: [PERMISSIONS.LAB_PANEL.LIST],
      ...defaultConfig,
      },
      {
        path: "/lab-pannel-import",
        exact: true,
        element:LabPannelImport,
        acl: [PERMISSIONS.LAB_PANEL.LIST],
        ...defaultConfig,
      },
       {
        path: "/video-configure",
        exact: true,
        element:VideoConfigList,
        acl: [PERMISSIONS.TUTORIAL_VIDEO.LIST],
        ...defaultConfig,
      },
      {
        path: "/notification-template",
        exact: true,
        element:NotificationTemplateList,
        acl: [PERMISSIONS.NOTIFICATION_TEMPLATE.LIST],
        ...defaultConfig,
      },
      {
        path: "/data-permission-template",
        exact: true,
        element: DataPermissionTemplateList,
        acl: [PERMISSIONS.DATA_PERMISSION_TEMPLATE.LIST],
         ...defaultConfig,
      },
      // {
      //   path: "/clearing-house",
      //   exact: true,
      //   element: ClearingHouseContainer,
      //   acl: [PERMISSIONS.CLEARING_HOUSE.LIST],
      //   ...defaultConfig,
      // },

  
  
  
  
];

export default PublicRoutes;
